module.exports = __webpack_public_path__ + "img/Sample-Agmt.6e718544.jpg";